export default "__VITE_ASSET__DeqnoHYS__"